import i18n from '../locales/i18n';

export default i18n;
